export default {"src":"/_next/static/media/CameraVideo.f28cca92.svg","height":18,"width":18};